module.exports = {
    PAGE_GENERIC: 'generica',
    PAGE_LOGIN: 'login',
    PAGE_ERROR: 'error',
    PROC_START: 'inicio',
    PROC_SUCCESS_CREATE_CONSENT: 'ir-exito/crear consentimiento',
    PROC_RESTART: 'reinicio',
    PROC_STEP: 'paso_',
    PROC_END: 'exito',
    PROC_FAIL: 'error',
    PROC_CANCEL: 'cancelado',
    PROC_SELECT_ENTITY: 'seleccion entidad',
    PROC_MANAGE_ENTITIES_AGGREGATOR: 'ajustes entidades agregador',
    PROC_MANAGE_ACCOUNTS_AGGREGATOR: 'ajustes cuentas agregador',
    PROC_REVIEW: 'revisar',
    PROC_GO_TO: 'ir a',
    PROC_BUY_GDI: 'Proc-broker-Carteras modelo',
    PROC_ACTIVATE_CARD: 'activacion de tarjeta',
    PROC_ADD_DOCUMENTATION: 'adjuntar documentacion',
    PROC_CHANGE_ACCESS_CODE: 'modificacion de clave',
    PROC_CHANGE_PERSONAL_DATA: 'modificacion de datos personales',
    PROC_CHANGE_PICTURE: 'modificacion de imagen',
    PROC_CONTRACTS: 'proc-contratos',
    PROC_FILTER_ACCOUNT_DEBITS: 'proc-filtro-domiciliaciones-cuenta',
    PROC_FILTER_ACCOUNT_TRANSACTIONS: 'proc-filtro-transacciones-cuenta',
    PROC_FILTER_DOCUMENTS: 'proc-filtro-documentos',
    PROC_FILTER_EMITTED_TRANSFERS: 'proc-filtro-transferencias-emitidas',
    PROC_FILTER_RECEIVED_TRANSFERS: 'proc-filtro-transferencias-recibidas',
    PROC_FILTER_SCHED_TRANSFERS: 'proc-filtro-transferencias-programadas',
    PROC_FILTER_CARDS_TRANSACTIONS: 'proc-filtro-transacciones-tarjeta',
    PROC_GET_DEBIT_PDF: 'proc-ver-pdf-domiciliacion',
    PROC_CROSS_SELLING_COMMERCIAL_AD: 'proc-clic-cross-selling-commercial-ad',
    PROC_PROMOTION_BANNER_COMMERCIAL_AD: 'proc-click-promotion-banner-commercial-ad',
    PROC_SIGNATURE_PATTERN: 'proc-otp',
    PROC_OK_DISCOUNTS_REDIRECT: 'proc-ok-discount-redirect',
    PROC_OK_DISCOUNTS_REGISTER: 'proc-ok-discount-register',
    PROC_HIRE_PROMOTIONS: 'proc-hire-promotions',
    PROC_HIRE_PRE_GRANTED_CREDIT: 'proc-hire-pre-granted-credit',
    PROC_INTERSTITIAL: 'proc-interstitial-display',
    PROC_LEGAL_INTERSTITIAL_FIOC: 'actualizacion fioc / mensaje %s dias',
    PROC_REFER_A_FRIEND: 'proc-invita a un amigo',
    PROC_COMMERCIAL_INTERSTITIAL: 'interstitial comercial',
    PROC_GDPR_INTERSTITIAL: 'interstitial GDPR',
    PROC_GDPR_CONSENTS: 'proc-consentimiento',
    PROC_GDPR_CONSENTS_CONTRACTS: 'proc-contratos-consentimiento',
    PROC_DISCOUNTS: 'interaccion en descuentos',
    PROC_COMMERCIAL_SPACE: 'visualización espacio comercial',
    PROC_AUTHORIZATION_RECEIPTS_RETURN: 'proc-cuenta-domiciliacion-devolucion',
    PROC_AUTHORIZATION_RECEIPTS_ANNULATION: 'proc-cuenta-domiciliacion-anulacion',
    PROC_AUTHORIZATION_RECEIPTS_ACTIVATION: 'proc-cuenta-domiciliacion-activacion',
    PROC_ADD_ENTITY: 'proc-agregar-entidad',
    PROC_ADD_ENTITY_ERROR: 'agregar-entidad-error',
    PROC_AGGREGATOR: 'agregador',
    PROC_CARD_REVOLVING: 'tarjeta-revolving',
    PROC_CARD_VIRTUAL_CREDIT: 'tarjeta virtual only credit',
    PROC_CHECKING_ACCOUNT: 'Nueva Cuenta Corriente Open',
    PROC_PACK_OPEN_YOUNG: 'pack open young',
    PROC_UPGRADE_TO_PAYROLL_ACCOUNT: 'Convertir a Cuenta Nómina Open',
    PROC_PAYROLL_ACCOUNT: 'Nueva Cuenta Nomina Open',
    PROC_CONTRACT_PAYROLL_LOAN: 'proc-contratacion-prestamo-nomina',
    PROC_OPEN_YOUNG_CONTACT_DATA: 'proc-datos-menor-contacto',
    PROC_OPEN_YOUNG_FISCAL_DATA: 'proc-datos-menor-fiscales',
    PROC_MODIFY_DEBIT_LIMITS_COMMERCE: 'proc-modificar-limite-comercios',
    PROC_MODIFY_DEBIT_LIMITS_EXTRACT: 'proc-modificar-limite-cajeros',
    PROC_RA_CANCEL_CONTRIBUTIONS: 'proc-cancelacion-aportaciones',
    PROC_RA_CANCEL_SERVICE: 'proc-cancelacion-servicio',
    PROC_RA_CONTRACTS: 'proc-contratos',
    PROC_RA_MODIFY_STRATEGY: 'proc-robo-modificar-estrategia',
    PROC_RA_NEW_CONTRIBUTION: 'proc-nueva-aportacion',
    PROC_RA_REFUND: 'proc-reembolso',
    PROC_RA_SUITABILITY_TEST: 'proc-robo-test-idoneidad',
    PROC_ONG_SEARCHER: 'interaccion buscador ONG',
    PROC_ONG_RESULT_CLICK: 'clic resultado ',
    PROC_INSERT_OTP_PROCESS: 'proc-agregador-clave',
    PROC_INSERT_OTP_PAGE: 'proc-agregador-clave-1',
    PROC_INSERT_OTP_SUCCESS_PAGE: 'proc-agregador-clave-exito',
    PROC_INSERT_OTP_SUCCESS_STEP: 'exito',
    PROC_INSERT_OTP_ERROR_PAGE: 'proc-agregador-clave-error',
    PROC_INSERT_OTP_ERROR_STEP: 'error',
    PROC_INSERT_OTP: 'terminar/introducir clave',
    PROC_NOT_RECEIVED_OTP: 'terminar/no he recibido la clave',
    PROC_EXPIRED_OTP_REQUEST_OTP: 'clave-expirada/solicitar nueva clave',
    PROC_EXPIRED_OTP_REMOVE_ENTITY: 'clave-expirada/eliminar banco',
    PROC_ERROR_CONNECTION_REQUEST_OTP: 'error-conexion/solicitar nueva clave',
    PROC_ERROR_CONNECTION_REMOVE_ENTITY: 'error-conexion/eliminar banco',
    PROC_OTP_MODAL_REQUEST_OTP: 'modal-clave/solicitar nueva clave',
    PROC_OTP_MODAL_CLOSE: 'modal-clave/cerrar',
    PROC_INSERT_OTP_FROM_ADVICE: 'terminar/introducir clave/card',
    PROC_INSERT_OTP_CLOSE_ADVICE: 'terminar/cerrar/card',
    PROC_EXPIRED_OTP_FROM_ADVICE: 'clave-expirada/solicitar nueva clave/card',
    PROC_EXPIRED_OTP_CLOSE_ADVICE: 'clave-expirada/cerrar/card',
    FISCAL_DATA_FATCA: 'proc-datos-fiscales',
    EVENT_ADD_ENTITY_WITHOUT_ENTITIES: 'añadir entidad 0',
    EVENT_ADD_MORE_ENTITY: 'añadir más entidades',
    EVENT_ERROR_ENTITY: 'error entidad',
    EVENT_ACTIVATE: 'activar',
    EVENT_CLICK: 'click',
    EVENT_DESACTIVATE: 'desactivar',
    EVENT_REMOVE: 'eliminar',
    EVENT_TOGGLE_ON: 'encendido',
    EVENT_TOGGLE_OFF: 'apagado',
    EVENT_ESP_ONLY: 'solo-ESP',
    EVENT_CARD_CONTROL: 'card-control',
    EVENT_ATMS: 'cajeros',
    EVENT_IN_PERSONAL_PURCHASES: 'compras-fisicas',
    EVENT_ONLINE_PURCHASES: 'compras-online',
    PROC_INTERACTION_NGO: 'interaccion en ONGs',
    PROC_INTERACTION_FOOTER: 'interaccion en footer',
    PROC_SELECT_CARD_DESIGN: 'seleccionar diseño de tarjeta',
    PROC_SELECT_PIN: 'select pin',
    PROC_SHOW_DETAILS_NGO: 'ver detalles de las ong',
    PROC_TRANSFER: 'transferir',
    PROC_AGGREGATOR_ENTITY_SUCCESS: 'proc-agregar-entidad-ir-exito',
    PROC_AGGREGATOR_ENTITY_SECOND_STEP: 'proc-agregar-entidad-ir-paso_2',
    PROC_AGGREGATOR_ENTITY_ERROR: 'proc-agregar-entidad-ir-error',
    PROC_AGGREGATOR_RENEW_ENTITY_ERROR_BLOCKED: 'renovar-sesion-error/usuario-bloqueado',
    PROC_AGGREGATOR_RENEW_ENTITY_RETRY: 'renovar-sesion-error/reintentar',
    PROC_AGGREGATOR_RENEW_SESSION_SUCCESS: 'proc-agregar-renovar-sesion-exito',
    PROC_AGGREGATOR_RENEW_SESSION: 'proc-agregar-renovar-sesion',
    PROC_AGGREGATOR_RENEW_FIRST_SESSION: 'proc-agregar-renovar-sesion-1',
    PROC_AGGREGATOR_RENEW_FIRST_SESSION_GO_TO: 'renovar-sesion-1/ir a',
    PROC_AGGREGATOR_RENEW_ENTITY_GO_TO_BLOQUED_USER: 'ir-error/usuario-bloqueado',
    PROC_AGGREGATOR_CONSENT: 'proc-agregar-consentimiento',
    PROC_AGGREGATOR_CONSENT_FIRST_STEP: 'proc-agregar-consentimiento-paso_1',
    PROC_AGGREGATOR_CONSENT_FIRST_STEP_GO_TO: 'proc-agregar-consentimiento-paso_1/ir a',
    PROC_AGGREGATOR_CONSENT_SUCCESS: 'proc-agregar-consentimiento-exito',
    PROC_AGGREGATOR_CONSENT_SUCCESS_ENTER_CREDENTIALS: 'proc-agregar-consentimiento-exito/ingresar credenciales',
    PROC_AGGREGATOR_CONSENT_ERROR: 'proc-agregar-consentimiento-error',
    PROC_AGGREGATOR_CONSENT_RETRY: 'consentimiento-error/reintentar',
    PROC_AGGREGATOR_RENEW_CONSENT: 'proc-agregar-crear-consentimiento',
    PROC_AGGREGATOR_RENEW_CONSENT_1: 'proc-agregar-crear-consentimiento-1',
    PROC_AGGREGATOR_RENEW_CONSENT_GO_TO: 'crear-consentimiento-1/ir a',
    PROC_AGGREGATOR_RENEW_CONSENT_SUCCESS: 'proc-agregar-crear-consentimiento-exito',
    PROC_AGGREGATOR_RENEW_CONSENT_ERROR: 'proc-agregar-crear-consentimiento-error',
    PROC_AGGREGATOR_RENEW_CONSENT_RETRY: 'crear-consentimiento-error/reintentar',
    PROC_GO_SECOND_STEP: 'ir-paso_2',
    PROC_FIRST_STEP: 'paso_1',
    PROC_GO_ERROR_STEP: 'ir-error',
    PROC_ERROR_RETRY: 'ir-error/reintentar',
    PRODUCT_NAME: {
        OPEN_YOUNG: 'tarjeta prepago open young',
        ECARD: 'tarjeta prepago ecard',
        CHARITY: 'tarjeta solidaria',
        VIA_T: 'via-t',
        MINI_CARD: 'tarjeta de debito minicard',
        OPEN_DEBIT: 'tarjeta de debito open debit',
        CARD_CREDIT: 'tarjeta de credito open credit',
        PREMIUM_CARD: 'pack de debito y credito premium',
        DIAMON_CARD: 'pack de debito y credito diamond',
        EMPTY_CASE: 'no especificado',
    },
    PAGE_MORTGAGE_REQUEST: 'solicitud-hipoteca',
    PROC_MORTGAGE_REQUEST: 'proc-solicitud-hipoteca',
    EVENT_INTERACTION_MORTGAGE_REQUEST: 'interaccion en solicitud hipoteca',
    EVENT_ACTION_SELECT_DATE: 'seleccionar fecha',
    EVENT_ACTION_SELECT_ANOTHER_DATE: 'elegir otra fecha',
    EVENT_ACTION_DOWNLOAD_LETTER: 'descargar carta pre-aprobación',
}
